import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate, CHANNEL_LABEL, TONE_CONFIG } from "@/lib/format";
import { Send, MessageSquare } from "lucide-react";

export default function Seguimiento() {
  const [campaigns, setCampaigns] = useState([]);
  const [comms, setComms] = useState([]);

  useEffect(() => {
    api.get("/campaigns").then((r) => setCampaigns(r.data)).catch(() => {});
    api.get("/communications").then((r) => setComms(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-slate-900">Seguimiento</h1>
        <p className="text-slate-500 mt-1">Campañas y comunicaciones enviadas.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
        <h2 className="font-display font-semibold text-slate-800 mb-4 flex items-center gap-2"><Send size={18} className="text-blue-600" /> Campañas de recordatorio</h2>
        {campaigns.length === 0 ? <p className="text-sm text-slate-400 py-6 text-center">Aún no se han enviado campañas.</p> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-xs uppercase text-slate-500 border-b border-slate-100">
                <th className="text-left py-2 px-2">Fecha</th><th className="text-left py-2 px-2">Canal</th><th className="text-left py-2 px-2">Tono</th>
                <th className="text-right py-2 px-2">Objetivo</th><th className="text-right py-2 px-2">Enviados</th><th className="text-right py-2 px-2">No config.</th><th className="text-right py-2 px-2">Omitidos</th>
              </tr></thead>
              <tbody>
                {campaigns.map((c) => (
                  <tr key={c.id} className="border-b border-slate-50">
                    <td className="py-2.5 px-2 text-slate-600">{formatDate(c.created_at)}</td>
                    <td className="py-2.5 px-2">{CHANNEL_LABEL[c.channel]}</td>
                    <td className="py-2.5 px-2">{TONE_CONFIG[c.tone]?.label || c.tone}</td>
                    <td className="py-2.5 px-2 text-right">{c.target_count}</td>
                    <td className="py-2.5 px-2 text-right text-emerald-600 font-medium">{c.sent}</td>
                    <td className="py-2.5 px-2 text-right text-amber-600">{c.not_configured}</td>
                    <td className="py-2.5 px-2 text-right text-slate-400">{c.skipped}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
        <h2 className="font-display font-semibold text-slate-800 mb-4 flex items-center gap-2"><MessageSquare size={18} className="text-teal-600" /> Comunicaciones recientes</h2>
        {comms.length === 0 ? <p className="text-sm text-slate-400 py-6 text-center">Sin comunicaciones registradas.</p> : (
          <div className="space-y-2 max-h-[500px] overflow-y-auto">
            {comms.map((c) => (
              <div key={c.id} className="p-3 rounded-lg bg-slate-50 border border-slate-100">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-semibold text-slate-700">{c.worker_name}</span>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-slate-400">{CHANNEL_LABEL[c.channel]}</span>
                    <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full ${c.status === "SENT" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                      {c.status === "SENT" ? "Enviado" : "No configurado"}
                    </span>
                  </div>
                </div>
                <p className="text-xs text-slate-500 line-clamp-2 whitespace-pre-line">{c.body}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
